<template>
  <div class="floor-layout">
    <div class="floor-container-wrap">
      <canvas id="markLayoutPreviewCanvas"></canvas>
      <canvas id="markLayoutPreviewMiniMap"></canvas>
    </div>
  </div>
</template>

<script>

import { queryMarkLayout } from '@/api/index'
import MarkPreview from '@/lib/markPreview'
const LZString = require('lz-string');
export default {
  props: {
    id: 0,
    height: {},
    floorData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    roomList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      markPreview: null,
    }
  },

  methods: {
    initMarkView: function () {
      return new Promise((resolve, reject) => {
        this.markPreview = new MarkPreview()
        this.markPreview.render((room) => {
          //点击事件
          this.$emit('clickRoomDetial', room)
        })

        resolve()
      })

    },

    //由外部父组件调用 获取座位数据
    getLayOutData: async function () {
      //查看当前本地是否有该房间的座位数据
      let seatCacheData = await this.$localForage.getItem(`room${this.id}`),
        layout = '', updV = 0, splits = "_updVersion_";


      if (seatCacheData != null) {
        let seatDataArray = seatCacheData.split(splits);

        // 兼容老数据
        if (seatDataArray.length > 1) { // 未加密的数据
          this.$localForage.setItem(`room${this.id}`, LZString.compressToBase64(seatCacheData))
        } else { // 加密数据解密
          seatCacheData = LZString.decompressFromBase64(seatCacheData)
          seatDataArray = seatCacheData.split(splits);
        }

        layout = seatDataArray[0], updV = seatDataArray.length == 2 ? seatDataArray[1] : 0;
      }
      let parame = {
        id: this.id,
        updV: updV
      }
      queryMarkLayout(parame).then(async res => {
        if (res.data.status) {
          if (res.data.data) { //如果返回了座位数据 则更新缓存
            let roomData = res.data.data;
            this.$localForage.setItem(`room${this.id}`, LZString.compressToBase64(roomData))
            layout = roomData.split(splits)[0]
          }

          this.renderData(layout || "{}")
        }
      })
    },
    renderData: function (floorData) {
      this.markPreview.reRender(JSON.parse(floorData), (sign) => {
        let roomBlockMap = {}
        for (var i = 0; i < sign.length; i++) {
          let data = sign[i].markData
          roomBlockMap[data.roomId ? data.roomId : data.markId] = sign[i]
        }
        // 渲染
        this.getRoomData(roomBlockMap)
      })
    },
    getRoomData: function (roomBlockMap) {
      this.$nextTick(() => {
        for (let roomIndex in this.roomList) {
          let roomId = this.roomList[roomIndex].id
          let sign = roomBlockMap[roomId]
          if (sign && this.id == this.roomList[roomIndex].floorId) {
            this.markPreview.addExtraElement(this.roomList[roomIndex], sign)
          }
        }
      })
    },

  },
  created () {
    let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
    this.jdzlCount = parseInt(systemInfo.superviseAway) > 0
    this.systemInfo = systemInfo
  },
  mounted () {
    this.initMarkView()
  }
}
</script>
<style>
.resourceMarkMiniMap1 {
  width: 100px !important;
  height: 50px !important;
  position: absolute !important;
  user-select: none;
  right: 0 !important;
  top: 0 !important;
}

#markLayoutPreviewMiniMap {
  width: 100px !important;
  height: 50px !important;
}
.resourceMarkCanvasContainer {
    border: 1px solid rgb(137 131 131 / 10%);
    box-sizing: content-box;
}
</style>
<style lang="less" scoped>

//详情弹框
.floor-layout {
  padding-top: 20px;
  padding-bottom: 50px;
  background: #fff;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .floor-container-wrap {
    margin: 0 auto;
    // overflow: auto;
    overflow: hidden;
    position: relative;
  }

  .roomList {
    position: relative;
    z-index: -9;
    display: flex;
    opacity: 0;

    // bottom: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/tabs/components/FloorLayout.vue